module.exports = __webpack_public_path__ + "img/red_square.a766493d.svg";